"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function parseBoolean(val) {
    if (val) {
        if (val.toLowerCase() === 'yes' || val === 'نعم') {
            return (true);
        }
        if (val.toLowerCase() === 'no' || val === 'لا') {
            return (false);
        }
    }
    return (undefined);
}
exports.parseBoolean = parseBoolean;
function booleanAsString(val, isArabic) {
    if (val !== undefined) {
        if (val) {
            return (isArabic ? 'نعم' : 'yes');
        }
        return (isArabic ? 'لا' : 'no');
    }
    return ('');
}
exports.booleanAsString = booleanAsString;
//# sourceMappingURL=boolean.js.map